export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/chevron-down.ce95fae6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};